import type { Dispatch } from "@reduxjs/toolkit";
import {
  BackgroundTask,
  setBackgroundTask,
} from "@/components/state/backgroundTasks/backgroundTasksSlice";
import { TaskChannelMessageType } from "@/types/taskChannelTypes";

export const BACKGROUND_TASK_CHANNEL_NAME = "background_tasks";

export type StartedBackgroundTask = Omit<
  BackgroundTask,
  "status" | "isWatcher"
>;

export const announceBackgroundTaskToOtherTabs = (
  task: StartedBackgroundTask
) => {
  if (typeof BroadcastChannel === "undefined") return;
  const channel = new BroadcastChannel(BACKGROUND_TASK_CHANNEL_NAME);
  channel.postMessage({ type: TaskChannelMessageType.STARTED, task });
  channel.close();
};

export const startBackgroundTask = (
  dispatch: Dispatch,
  task: StartedBackgroundTask
) => {
  dispatch(setBackgroundTask(task));
  announceBackgroundTaskToOtherTabs(task);
};
